import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import HomeSidebar from "@/pages/home/components/HomeSidebar";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";
import { useSeo } from "@/hooks/useSeo";
import {
  getLatestMovies,
  getPopularMovies,
  getTopicMovies,
} from "@/lib/catalog";

export default function Home() {
  useSeo({
    title: "年轻的母亲在线 - 影视资源在线观看平台",
    description:
      "年轻的母亲在线提供丰富的影视资源，涵盖电影和电视剧，支持在线观看和剧情介绍，满足各类观影需求。",
    keywords:
      "年轻的母亲在线,年轻的母亲,在线观看,影视资源,电影,电视剧,剧情介绍",
  });

  const latest = getLatestMovies(8);
  const popular = getPopularMovies(6);
  const topic = getTopicMovies();

  return (
    <div>
      <HeroCarousel />

      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-12">
        {/* 分类快捷入口 */}
        <section className="mb-12">
          <SectionHeading
            icon="ri-apps-2-line"
            title="快速分类"
            subtitle="按分类快速进入，找到你想看的影视内容"
          />
          <CategoryEntries />
        </section>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          {/* 左侧主内容 */}
          <div className="lg:col-span-2 flex flex-col gap-12">
            <section>
              <SectionHeading
                icon="ri-time-line"
                title="最新更新"
                subtitle="及时上线的影视资源，第一时间了解新内容"
                moreTo="/category/movie"
              />
              <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-6">
                {latest.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            </section>

            <section>
              <SectionHeading
                icon="ri-fire-line"
                title="热门推荐"
                subtitle="点击量与收藏数领先的高人气影视精选"
                moreTo="/category/tv"
              />
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-6">
                {popular.map((movie, i) => (
                  <MovieCard key={movie.id} movie={movie} rank={i + 1} />
                ))}
              </div>
            </section>
          </div>

          {/* 右侧栏 */}
          <HomeSidebar />
        </div>

        {/* 专题推荐区 */}
        <section className="mt-12 md:mt-16 rounded-lg bg-background-100 border border-background-200 overflow-hidden">
          <div className="p-5 md:p-7 flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
            <div className="md:w-2/5">
              <span className="inline-flex items-center gap-1.5 px-3 h-7 rounded-full bg-accent-500 text-foreground-950 text-xs font-semibold">
                <i className="ri-bookmark-3-line"></i>
                主题企划
              </span>
              <h2 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-tight">
                年轻的母亲
                <br />
                主题影视专题
              </h2>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                围绕“年轻的母亲”这一温暖主题，精选多部关于亲情、成长与坚守的影视作品，带你走进她们动人的故事。
              </p>
              <Link
                to="/category/topic"
                className="mt-5 px-5 h-11 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                进入专题
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="md:w-3/5">
              <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-4 gap-3">
                {topic.slice(0, 4).map((movie) => (
                  <Link
                    key={movie.id}
                    to={`/detail/${movie.id}`}
                    className="group block cursor-pointer"
                  >
                    <span className="block w-full aspect-[2/3] rounded-md overflow-hidden bg-background-200">
                      <img
                        src={movie.cover}
                        alt={`${movie.title} 专题海报`}
                        title={`${movie.title} - 年轻的母亲专题`}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </span>
                    <span className="mt-2 block text-xs text-foreground-800 line-clamp-1 group-hover:text-primary-600 transition-colors">
                      {movie.title}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}